import { useTranslation } from 'react-i18next';

import { DataPanelAutoWrapInlineItem } from '@/ui';

export type SourceUnavailablePanelItemProps = {
  sourceId: string;
};

export function SourceUnavailablePanelItem({ sourceId }: SourceUnavailablePanelItemProps) {
  const { t } = useTranslation();

  return (
    <DataPanelAutoWrapInlineItem
      title={t('Incident_InfoPanel_SourceDetailUnavailable')}
      value={sourceId}
      color="warning"
    />
  );
}
